import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';

function App() {
  return (
    <Container 
      maxWidth="sm" 
      sx={{ 
        textAlign: 'center', 
        mt: 15, 
        backgroundColor: '#f9f9f9', 
        padding: 4, 
        borderRadius: 3,
        boxShadow: 3 
      }}
    >
      <Typography variant="h2" gutterBottom sx={{ fontWeight: 'bold' }}>
        GoCourier
      </Typography>
      <Typography variant="h5" color="text.secondary" gutterBottom>
        Coming Soon
      </Typography>
      <Typography variant="body1" sx={{ mt: 4 }}>
        A platform connecting businesses, couriers, and trucking companies.
      </Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Built with AI to improve transportation logistics.
      </Typography>
      <Box sx={{ mt: 5 }}>
        <Button
          variant="contained"
          color="primary"
          href="mailto:info@gocourier.ai"
          startIcon={<EmailIcon />}
          sx={{
            paddingX: 4,
            paddingY: 1.5,
            fontSize: '1rem',
            textTransform: 'none',
            borderRadius: 2,
            boxShadow: 2
          }}
        >
          Contact Us
        </Button>
      </Box>
    </Container>
  );
}

export default App;
